// extracted by mini-css-extract-plugin
module.exports = {"informationCard":"InformationCard_informationCard__2ocxo","text":"InformationCard_text__34oXi"};